import React from 'react';
import { find } from 'lodash';

// React view component to render
import { addEditAddressForm as AddEditAddressFormView } from 'ui/views/widgets/addEditAddressForm';
import { MemberAddEditAddressService } from 'services/memberAddEditAddress';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { popover } from 'modules/popover';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AddEditAddressForm } from 'ui/containers/AddEditAddressForm';
 *
 * // render
 * <AddEditAddressForm propName='propValue'/>
 */
export class AddEditAddressForm extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: false,
            addressOptions: {},
            mode: 'form',
            selected: {}
        };

        this._bind();

        // create service instance
        this.memberAddEditAddressService = new MemberAddEditAddressService();
    }

    _bind() {
        this.handleFormSubmit = this.handleFormSubmit.bind( this );
        this.handleAddressSelection = this.handleAddressSelection.bind( this );
    }

    /**
     * action executed, wehen user makes an address selection
     */
    handleAddressSelection( { selectionType, address } ) {
        log.debug( 'AddEditAddressForm.handleAddressSelection()' );

        this.setState( {
            selected: {
                selectionType,
                address
            }
        } );
    }

    /**
     * action executed when user clicks on form submit
     */
    async handleFormSubmit( formData ) {
        log.debug( 'AddEditAddressForm.handleFormSubmit()' );

        // close opened popovers
        popover.close();

        // cancel ongoing request
        this.memberAddEditAddressService.cancel();

        // show page preloader
        pageLevelPreloader.show();

        const url = find( this.props.actions, { name: 'save' } )[ 'url' ];

         // set the address default
        const { status, data } = await this.memberAddEditAddressService.fetchValidAddresses( {
            url,
            data: formData
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            this.setState( {
                addressOptions: data,
                mode: 'selection',
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS
            } );

        } else {

            this.setState( {
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            }, () => {
                errorOverlay.open();
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AddEditAddressFormView
                { ...this.state }
                { ...this.props }
                onFormSubmit = { this.handleFormSubmit }
                onSelectAddressClick={ this.handleAddressSelection }
            />
        );
    }
}

// set display name
AddEditAddressForm.displayName = 'AddEditAddressForm';

// set default props
AddEditAddressForm.defaultProps = {};

// prop types
AddEditAddressForm.propTypes = {};
